module.exports = __webpack_public_path__ + "img/new-widget.0a05cd35.png";